module.exports = __webpack_public_path__ + "static/media/checked.e5e94bf5.svg";